import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import LazyLoad from 'react-lazyload';
import { Card, Skeleton } from 'antd';
import styles from './styles.less';

const CustomCard = ({ blog }) => {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (Object.keys(blog).length) {
      setLoading(false);
    }
  }, [blog]);

  return (
    <div className={styles.cardContainer}>
      <Card
        className={styles.card}
        cover={
          <div className={styles.imageContainer}>
            {!loading && (
              <LazyLoad>
                <img alt={blog.title} src={blog.image} />
              </LazyLoad>
            )}
          </div>
        }
      >
        <Skeleton loading={loading} active>
          <Card.Meta
            title={
              <>
                <span dangerouslySetInnerHTML={{ __html: blog.title }} />
                {blog.author && (
                  <div className={styles.authorDate}>
                    <span>{blog.author.name}</span>
                    <span>{moment(blog.date).format('DD MMM')}</span>
                  </div>
                )}
              </>
            }
            description={
              blog.excerpt && (
                <span className={styles.description}>
                  {blog.excerpt.replace(blog.excerpt.match(/\[vc_raw_html].+\[\/vc_raw_html]/), '')}
                </span>
              )
            }
          />
        </Skeleton>
      </Card>
    </div>
  );
};

CustomCard.propTypes = {
  blog: PropTypes.object.isRequired,
};

export default CustomCard;
